import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const FullWidthPhoto = ({ data }) => {
  const { Photo } = data;
  const image = getImage(Photo?.localFile);
  return (
    <section className=" my-26">
      <GatsbyImage image={image} alt="image" />
    </section>
  );
};

export default FullWidthPhoto;
